<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="articulos-stock-inicial" titulo="Artículos / Catalogo" [dato]="dato"></app-formulario>

<!-- Menu principal  menutitulo="titulo del modulo en el que estamos con el nombre como se encuentra en enviroment" menuactual="nombre del hub donde estamos como se especifico en el routing"-->
<app-sistema-menu menutitulo="Catalogo" menuactual="catalogo"></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">

    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda menutitulo="titulo del modulo enviroment" -->
        <app-sistema-menu-aside menuactual="Catalogo"></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- inicio formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="guardarDatos(false, false)">
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <nav class="level ">
                            <!-- Left side -->
                            <div class="level-left ">
                                <div class="level-item">
                                    <p class="title">
                                        <span *ngIf="!ctrl.cargando || !cargando" class="icon is-medium">
                                            <i class="icon-list-12"></i>
                                        </span>
                                        <span *ngIf="ctrl.cargando || cargando" class="icon is-medium">
                                            <i class="icon-worldwide fa-spin"></i>
                                        </span>
                                        Inicializar inventarios
                                    </p>
                                </div>
                            </div>
                        
                            <div class="level-right">
                                <a class="navbar-item tooltip" (click)="ctrl.regresar()">
                                    <span class="icon fa-2x">
                                        <i class="icon-back"> </i>
                                    </span>
                                    <span class="tooltiptext">Regresar</span>
                                </a>
                            
                                

                                <a class="navbar-item is-primary tooltip" (click)="cargarArticulos()" id='cargar_datos_actualizar'>
                                    <span class="icon ">
                                        <i class="icon-worldwide fa-2x"></i>
                                    </span>
                                    <span class="tooltiptext">Actualizar</span>
                                </a>

                                <button class="button is-primary tooltip" type="submit" [ngClass]="{'is-loading': cargando}" [disabled]="dato.invalid">
                                    <span class="icon ">
                                        <i class="icon-diskette fa-2x"> </i>
                                    </span>
                                    <span class="tooltiptext">Guardar</span>
                                </button>
                            </div>
                        </nav>
                    </div>
                </section>
                <div class="is-fullwidth has-text-centered" *ngIf="cargando">
                    <br>
                    <span class="tag is-primary is-large "><span class="icon"><i class="icon-worldwide fa-spin"></i></span> &nbsp;<span>Cargando...</span></span>
                </div>

                <section class="section" style="padding: 1rem !important; overflow:auto; height: 85.8vh;" >

                    <div formArrayName="movimientos_articulos">
                        <div class="notification is-warning" *ngIf="!ctrl.guardado">
                            ¡Atención! <strong>En esta lista solo se cargan los productos que aun no tienen inventario</strong>
                                
                            <strong><br><br>Si necesita que se carguen todos los articulos y reestablecer el inventario de click acá <a class="button is-small" 
                                (click)="ctrl.abrirModal('confirmarReestablecer')">Resetear inventario</a></strong>
                            
                        </div>
                        <div class="notification is-success" *ngIf="ctrl.guardado">
                            ¡La carga se realizo correctamente! <strong>Puede regresar a listado para comprobarlo</strong> 
                            <a class="button is-small" routerLink="../lista">Listado</a>
                        </div>

                        <div class="notification is-danger" *ngIf="error">
                            ¡No se completo la inicialización! <strong>Intente de nuevo</strong>, Si no contacte con soporte
                        </div>
                        
                        <article class="media" *ngFor="let val of json_articulos | groupBy:'categorias.nombre'; let c = index;">
                            <figure class="media-left">
                                <p class="image is-64x64">
                                    <img [src]="val.value[0].categorias.foto ? ctrl.API_PATH+'/adjunto/categoria/'+val.value[0].categorias.foto : './assets/128x128.png'">
                                </p>
                            </figure>
                            <div class="media-content">
                                <div class="content">                                    
                                    <blockquote>
                                        <span >Categoria: {{val.key}}</span>
                                        <a class="button" (click)="cat[c] = !cat[c]" style="float:right">
                                            <span class="icon">
                                                <i class="icon-add2" *ngIf="!cat[c]"></i>
                                                <i class="icon-minus" *ngIf="cat[c]"></i>
                                            </span>
                                        </a>
                                    </blockquote>                                    
                                </div>

                                <article class="media" *ngFor="let item of val.value; let i=index" [style.display]="cat[c] ? 'flex' : 'none'">
                                    <figure class="media-left">
                                        <p class="image is-64x64">
                                            <img [src]="item.articulos_imagenes.length > 0 ? ctrl.API_PATH+'/adjunto/articulos/'+item.articulos_imagenes[0].imagen : './assets/128x128.png'">
                                        </p>
                                    </figure>
                                    <div class="media-content" [formGroupName]="item.contador">
                                        <div class="content">
                                            <p>
                                                <strong>{{item.nombre}} <small *ngIf="item.unidades_medidas">( {{ item.unidades_medidas.nombre }} )</small></strong>
                                                <strong class="tag is-dark is-medium"><span class="icon"><i class="fa fa-barcode"></i></span> &nbsp; {{ item.codigo_barras }}</strong>
                                                <strong class="tag is-warning is-medium">Clave: {{ item.clave }}</strong>
                                                <strong class="tag is-primary is-medium">Categoria: <span *ngIf="item.categorias">{{ item.categorias.nombre }}</span></strong>
                                                <strong class="tag is-primary is-medium">Presentación: <span *ngIf="item.presentaciones">{{ item.presentaciones.nombre }}</span></strong>
                                            </p>
                                        </div>

                                        <article class="media">
                                            <div class="control is-grouped">

                                                <a class="button is-success" (click)="agregar_lote(item.contador)">
                                                        <span class="icon">
                                                            <i class="icon-add2"></i>                                                        
                                                        </span> 
                                                        &nbsp;
                                                        Agregar nuevo lote
                                                    </a>
                                                <input *ngIf="!item.tiene_precio" class="input has-text-centered" type="text" placeholder="Precio de venta" formControlName="precio_venta">
                                                <strong *ngIf="item.tiene_precio" >
                                                    <small class="tag is-info is-small" *ngFor="let pr of item.precios">{{pr.nombre}}: $ {{pr.precio}}</small>
                                                </strong>
                                            </div>
                                        </article>

                                        <article class="media">
                                            <table class="table is-striped  is-fullwidth" *ngIf="ctrl.dato.controls.movimientos_articulos.controls[item.contador].controls.lotes">
                                                <thead>
                                                    <tr>
                                                        <th>Lote</th>
                                                        <th>Caducidad</th>
                                                        <th>Existencia</th>
                                                        <th>Costo</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody formArrayName="lotes">
                                                    <tr *ngFor="let val of ctrl.dato.controls.movimientos_articulos.controls[item.contador].controls.lotes.controls;  let i2 = index;" [formGroupName]="i2">
                                                        <td><input class="input has-text-centered" type="text" placeholder="Lote"
                                                                formControlName="lote"></td>
                                                        <td><input class="input has-text-centered" type="date" placeholder="Caducidad"
                                                                formControlName="fecha_caducidad"></td>
                                                        <td><input class="input has-text-centered" type="number" placeholder="Existencia"
                                                                formControlName="existencia"></td>
                                                        <td><input class="input has-text-centered" type="number" placeholder="Costo"
                                                                formControlName="precio_unitario"></td>
                                                        <td>
                                                            <a class="is-danger" title="Quitar este lote" (click)="quitar_lote(item.contador, i2)">
                                                                <span class="icon has-text-danger">
                                                                    <i class="icon-trash"></i>
                                                                </span>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </article>
                                    </div>
                                </article>

                            </div>
                        </article>
                    </div>

                    <!-- fin formulario -->
                </section>


            </form>
        </div>
    </div>
</div>

<div class="modal" id="confirmarReestablecer">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
        <p class="modal-card-title"><i class="fa fa-warning"></i> Alerta</p>
        <button class="delete" (click)="ctrl.cancelarModal('confirmarReestablecer')"></button>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <h1>¿Esta seguro de resetear el inventario?</h1>
                <p>esta acción cargaratodos los productos que tienen inventario para susutituirlo, es necesario llenar y guardar la inicialización de inventario para que se refleje en el stock</p>
            </div>
        </section>
        <footer class="modal-card-foot">
        <a class="button is-success" (click)="cargarArticulos('iniciar')" >Continuar</a>
        <a class="button" (click)="ctrl.cancelarModal('confirmarReestablecer')" id="cerra_restablecer">Cancelar</a>
        </footer>
    </div>
</div>